var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cabinet cabinet-supplier cabinet-full"},[_c(_vm.sideber,{tag:"component"}),_c('div',{staticClass:"cabinet-content full"},[_c('vue-progress-bar'),_vm._t("default"),_c('cabinet-footer')],2),_c('notifications')],1)}
var staticRenderFns = []

export { render, staticRenderFns }